<template>
  <div class="main-content">
    <div class="page-content">
      <div v-if="isLoading">Carregando...</div>
      <template v-else-if="boards.length">
        <template v-if="selected">
          <!-- modal log Task-->
          <app-modal-log :task_id="log_task_id" :board_name="selected.name" v-if="modalLogShow"
            @closeModalLog="closeModalLog" />
          <!-- modal export -->
          <app-modal-export :board="selected.id" :name="selected.name" v-if="modalExportShow"
            @setModalExportShow="setModalExportShow" />
          <!-- Modal config -->
          <app-modal-config :board="selected.id" :team_id="selected.team_id" :team="selected.team.users"
            :name="selected.name" v-if="modalShow" @setModalConfigShow="setModalConfigShow"
            @setModalConfigUsers="setModalConfigUsers" />
          <!-- Modal Form -->
          <app-modal-card v-if="active_id != null" :active_id="active_id" :board_id="selected.id"
            :board_name="selected.name" :board_users="selected.team.users" :userAdmin="userAdmin"
            @closeModalCard="closeModalCard" @openLogTask="openLogTask" />

          <!-- Header Page -->
          <app-board-header :title="selected.name" :userAdmin="userAdmin" :data="buckets" @newBucket="createNewBucket"
            @openForm="openForm" @setModalConfigShow="setModalConfigShow" @stopUpdateInterval="stopUpdateInterval"
            @startUpdateInterval="startUpdateInterval" />

          <!-- Boards -->
          <template v-if="$route.params.view === 'board'">
            <app-board :data="selected" :buckets="buckets" :userAdmin="userAdmin" :myTasksActive="myTasksActive"
              ref="contentAllBuckets" @newBucket="createNewBucket" @openForm="openForm" @setBucketName="setBucketName"
              @moveBucket="moveBucket" @deleteBucket="deleteBucket" @createNewTask="createNewTask"
              @deleteTask="deleteTask" @copyTask="copyTask" @updateCardValues="updateCardValues"
              @updateBucketData="updateBucketData" @taskUpdateStatus="taskUpdateStatus" @exportBoard="exportBoard"
              @setMyTasks="setMyTasks" @setModalExportShow="setModalExportShow" />
          </template>

          <!-- Dashboard -->
          <template v-if="$route.params.view === 'dashboad'">
            <app-dashboard :userAdmin="userAdmin" :selected="selected.task_model" :buckets="buckets" />
          </template>

          <!-- Pauta -->
          <template v-if="$route.params.view === 'pauta'">
            <app-pauta :userAdmin="userAdmin" @openForm="openForm" />
          </template>

        </template>
      </template>
      <div v-else>Nenhum board disponível.</div>
    </div>
  </div>
</template>

<script>
import AppBoardHeader from "@/components/AppBoardHeader/AppBoardHeader.vue";
import AppPauta from "./Pauta.vue";
import AppBoard from "./BoardTemplate.vue";
import AppModalCard from "./AppModalCard.vue";
import AppModalConfig from "./AppModalConfig.vue";
import AppModalExport from "./AppModalExport.vue";
import AppModalLog from "./AppModalLog.vue";
import AppDashboard from "./Dashboard.vue";
import { mapState, mapActions } from "vuex";
import Vue from "vue";

export default {
  props: {
    boards: {
      type: Array,
      default: () => []
    }
  },
  components: {
    AppBoardHeader,
    AppBoard,
    AppModalCard,
    AppPauta,
    AppModalConfig,
    AppDashboard,
    AppModalExport,
    AppModalLog
  },
  data() {
    return {
      myTasksActive: false,
      selected: null,
      isLoading: true,
      buckets: [],
      fakeBuckets: [],
      updateInterval: null,
      isEditing: false,
      formModal: [],
      userAdmin: 0,
      selectedIndex: null,
      selectedCount: null,
      selectedCountInput: null,
      selectedCountOutros: null,
      selectedCountInputOutros: null,
      modalShow: false,
      modalExportShow: false,
      modalConfigUsers: [],
      active_id: null,
      log_task_id: null,
      modalLogShow: false
    };
  },
  created() {
    this.initializeData();
  },
  mounted() {
    if (this.$route.params.view != "dashboad" && this.$route.params.view != "pauta") {
      this.startUpdateInterval();
    }
  },
  beforeDestroy() {
    this.stopUpdateInterval();
  },
  watch: {
    "$route.params.id": async function (newId) {
      console.log('$route.params.id', newId)
      await this.updateSelectedBoard(newId);
      await this.getBuckets(newId);
    },
    selected(newSelected) {
      this.determineUserAdmin(this.$store.state.users.id);
    },
    modalConfigUsers: function (newVal) {
      this.selected.team.users[0] = newVal;
    },
    boards: {
      async handler(newBoards) {
        if (newBoards.length) {
          const boardId = this.$route.params.id;
          await this.updateSelectedBoard(boardId);
          if (!this.selected) {
            this.isLoading = false;
            this.showMessage({
              title: "Board não encontrado!",
              css: "bg-danger"
            });
            return;
          }
          await this.getBuckets(boardId);
          if (this.$route.params.taskId) {
            setTimeout(() => {
              this.handleTaskIdChange(this.$route.params.taskId);
              this.isLoading = false;
            }, 2000);
          } else {
            this.isLoading = false;
          }
        } else {
          this.isLoading = false;
        }
      },
      immediate: true
    },
    buckets: {
      handler(newBuckets, oldBuckets) { },
      immediate: true
    },
    fakeBuckets: {
      handler(newVal, oldVal) {
        if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
          this.buckets = newVal;
        }
      },
      immediate: true
    }
  },
  methods: {
    ...mapState(["users"]),
    ...mapActions([
      "showMessage",
      "showLoader",
      "setLoaderTitle",
      "showBlockScreen"
    ]),
    setMyTasks() {
      this.myTasksActive = !this.myTasksActive;
      if (!this.myTasksActive) return this.getBucketsSilent();
      this.filterMyTasks();
    },
    filterMyTasks() {
      const userId = this.$store.state.users.id;
      this.filteredBuckets = this.fakeBuckets
        .map(bucket => {
          const filteredTasks = bucket.tasks.filter(task =>
            task.users.some(user => user.id === userId)
          );
          if (filteredTasks.length > 0) {
            return {
              ...bucket,
              tasks: filteredTasks
            };
          } else {
            return null;
          }
        })
        .filter(bucket => bucket !== null);
      this.fakeBuckets = this.filteredBuckets
    },
    startUpdateInterval() {
      if (this.$route.params.view === "dashboad" && this.$route.params.view === "pauta") {
        return this.stopUpdateInterval();
      }
      else {
        console.log("iniciando startUpdateInterval");
        if (!this.updateInterval) {
          this.updateInterval = setInterval(() => {
            this.getBucketsSilent();
          }, 45000); // 45000 milissegundos = 45 segundos
        }
      }
    },
    stopUpdateInterval() {
      console.log("parar stopUpdateInterval");
      if (this.updateInterval) {
        clearInterval(this.updateInterval);
        this.updateInterval = null;
      }
    },
    handleTaskIdChange(taskId) {
      if (taskId) {
        //index bucket
        let uri = taskId.split("-");
        console.log('cá estou!')
        this.openForm(parseInt(uri[0]), parseInt(uri[1]));
      }
    },
    initializeData() {
      this.getBuckets();
      //this.openForm(1);
      document.body.classList.add("modal-open");
    },
    updatePropertiesInSelected(propertie_id, completeData) {
      let selected = this.selected;
      let searchId = Number(propertie_id);
      //task_model
      let updated = selected.task_model[0].properties.map(el => {
        if (el.propertie_id === searchId) {
          el.propertie.values = completeData;
        }
        return el;
      });

      this.selected.task_model[0].properties = updated;
    },
    updateSelectedBoard(routeId) {
      const id = Number(routeId);
      this.selected = this.boards.find(board => Number(board.id) === id) || null;
      console.log('selected', this.selected)
      return true;
    },
    closeModalCard() {
      this.isEditing = false;
      this.getBucketsSilent();
      this.startUpdateInterval();
      this.formModal = [];
      this.active_id = null;
    },
    async getForm(id) {
      let boards = this.buckets;

      for (const board of boards) {

        // Verifica no array 'tasks'
        const task = board.tasks.find(task => task.id === id);
        if (task) {
          return task;
        }

        // Verifica no array 'taskCompletes'
        const taskComplete = board.taskCompletes.find(task => task.id === id);
        if (taskComplete) {
          return taskComplete;
        }
      }

      console.log('tarefa não encontrada, ', id);
      return null;
    },
    async openForm(bucket, id) {

      let result = await this.getForm(id);
      if (!result) {
        this.showMessage({
          title: "Tarefa não econtrada!",
          css: "bg-danger"
        });
      }
      this.active_id = id;
      //parar atualização de dados
      this.isEditing = true;
    },
    //Não atualizado
    getBucketsSilent() {
      const options = this.$getAPIHeaders(
        "GET",
        `board-buckets/${this.$route.params.id}`
      );
      this.axios(options)
        .then(response => {
          console.log("response getBucketsSilent", JSON.stringify(response.data.data.data));
          this.fakeBuckets = response.data.data.data;
          if (this.myTasksActive) return this.filterMyTasks();
        })
        .catch(error => {
          console.error(error);
        });
    },
    //Não atualizado
    async getBuckets(id) {
      if (!id) {
        this.isLoading = false;
        return;
      }
      const options = this.$getAPIHeaders("GET", `board-buckets/${id}`);
      await this.axios(options)
        .then(response => {
          //console.log(response.data.data.data);
          this.buckets = response.data.data.data;
          this.isLoading = false;
        })
        .catch(error => {
          console.error(error);
        });
    },
    //Não atualizado
    createNewBucket() {
      const data = { name: "Novo quadro", board_id: this.selected.id };
      const headers = this.$getAPIHeaders("POST", `bucket`, data);
      this.axios(headers)
        .then(response => {
          this.buckets.push(response.data.data);
        })
        .catch(error => {
          console.error(error);
        });

      const bucketList = document.querySelector(".bucket-list");
      if (bucketList) {
        bucketList.scrollLeft = bucketList.scrollWidth;
      }
    },
    //Não atualizado
    setBucketName(bucket) {
      const data = { name: bucket.name, ordered: bucket.ordered };
      const headers = this.$getAPIHeaders("PATCH", `bucket/${bucket.id}`, data);

      this.axios(headers).catch(error => {
        console.error(error);
      });
    },
    //Não atualizado
    moveBucket(columnId, direction) {
      const index = this.buckets.findIndex(bucket => bucket.id === columnId);
      if (index < 0) return;

      const swapIndex = direction === "up" ? index - 1 : index + 1;
      if (swapIndex < 0 || swapIndex >= this.buckets.length) return;

      // Swap logic
      [this.buckets[index], this.buckets[swapIndex]] = [
        this.buckets[swapIndex],
        this.buckets[index]
      ];
      [this.buckets[index].ordered, this.buckets[swapIndex].ordered] = [
        this.buckets[swapIndex].ordered,
        this.buckets[index].ordered
      ];

      // Send rearrangement to server
      const data = {
        items: [
          { id: this.buckets[index].id, ordered: this.buckets[index].ordered },
          {
            id: this.buckets[swapIndex].id,
            ordered: this.buckets[swapIndex].ordered
          }
        ]
      };
      this.buckets.sort((a, b) => a.ordered - b.ordered);

      const headers = this.$getAPIHeaders("POST", "bucket-ordered", data);

      this.axios(headers).catch(error => {
        console.error(error);
      });
    },
    //Não atualizado
    deleteBucket(bucketId) {
      this.buckets = this.buckets.filter(bucket => bucket.id !== bucketId);
      const headers = this.$getAPIHeaders("DELETE", `bucket/${bucketId}`);
      this.axios(headers).catch(error => {
        console.error(error);
      });
    },
    determineUserAdmin(userId) {
      const userList = this.selected.team.users.flat();
      const user = userList.find(u => u.id === userId);
      this.userAdmin =
        user && user.pivot ? parseInt(user.pivot.is_admin, 10) : 0;
    },
    //Não atualizado
    copyTask(bucketId, taskId) {

      const data = { bucket_id: bucketId, task_id: taskId };
      const headers = this.$getAPIHeaders("POST", `task-copy`, data);
      this.axios(headers).catch(error => {
        console.error(error);
      });
      setTimeout(() => this.closeModalCard(), 1000);
    },
    //Não Atualizado
    deleteTask(bucketId, taskId) {
      const bucketIndex = this.buckets.findIndex(b => b.id === bucketId);
      if (bucketIndex !== -1) {
        const bucket = this.buckets[bucketIndex];
        if (bucket.tasks && Array.isArray(bucket.tasks)) {
          bucket.tasks = bucket.tasks.filter(t => t.id !== taskId);
        }
        if (bucket.taskCompletes && Array.isArray(bucket.taskCompletes)) {
          bucket.taskCompletes = bucket.taskCompletes.filter(
            t => t.id !== taskId
          );
        }
        this.buckets = [...this.buckets];
        const headers = this.$getAPIHeaders("DELETE", `task/${taskId}`);
        this.axios(headers).catch(error => {
          console.error(error);
        });
        setTimeout(() => this.closeModalCard(), 1000);
      }
    },
    //Não atualizado
    createNewTask(bucketId) {
      const index = this.buckets.findIndex(b => b.id === bucketId);
      if (index === -1) {
        return;
      }
      const data = { bucket_id: bucketId, name: "Nova tarefa" };
      const headers = this.$getAPIHeaders("POST", `task`, data);
      this.axios(headers)
        .then(response => {
          const newTask = response.data.data;
          newTask.values = [];
          const clonedBucket = { ...this.buckets[index] };
          clonedBucket.tasks = clonedBucket.tasks || [];
          clonedBucket.tasks.push(newTask);
          this.buckets.splice(index, 1, clonedBucket);
          this.openForm(response.data.data.bucket_id, response.data.data.id);
        })
        .catch(error => {
          console.error(error);
        });
    },

    taskManageUser(bucketId, user, taskId) {
      // Encontre o bucket ativo
      let activeBucket = this.buckets.find(b => b.id === bucketId);
      if (activeBucket) {
        let searchTask = activeBucket.tasks.find(t => t.id === taskId);
        if (!searchTask) {
          searchTask = activeBucket.taskCompletes.find(t => t.id === taskId);
        }
        if (searchTask) {
          const data = { task: taskId, user_id: user.id };
          let userIndex = searchTask.users.findIndex(u => u.id === user.id);
          if (userIndex !== -1) {
            searchTask.users.splice(userIndex, 1);
            data.option = "remove";
          } else {
            searchTask.users.push(user);
            data.option = "add";
          }
          const headers = this.$getAPIHeaders("POST", `task-manage-user`, data);
          this.axios(headers).catch(error => {
            console.error(error);
          });
        }
      }
    },
    //Inativo
    taskUpdateStatus(bucket_id, task_id, v) {
      console.log('Função inativa taskUpdateStatus', bucket_id, task_id, v)
      /*
      let value = v.toString();
      const bucket = this.buckets.find(b => b.id === bucket_id);
      if (!bucket) {
        console.error("Bucket não encontrado");
        return;
      }
      const moveTask = (sourceList, targetList, task) => {
        const index = sourceList.indexOf(task);
        if (index > -1) {
          sourceList.splice(index, 1);
          targetList.push(task);
        }
      };
      let task = bucket.tasks.find(t => t.id === task_id);
      if (task) {
        if (value === "3") {
          task.status = value;
          moveTask(bucket.tasks, bucket.taskCompletes, task);
          bucket.totalCompletes++;
        } else {
          task.status = value;
        }
      } else {
        task = bucket.taskCompletes.find(t => t.id === task_id);
        if (task) {
          if (value !== "3") {
            task.status = value;
            moveTask(bucket.taskCompletes, bucket.tasks, task);
            bucket.totalCompletes--;
          }
        }
      }
      const data = {
        type: "status",
        value: value
      };
      this.updateDefaultValue(task_id, data);*/
    },
    //Inativo
    updateCardValues(bucketId, taskId, name, value) {
      console.log('Função inativa updateCardValues', bucketId, taskId, name, value)
      /*
      if (name === "status") {
        this.taskUpdateStatus(bucketId, taskId, value);
        return;
      }
      let activeBucket = this.buckets.find(b => b.id === bucketId);
      const defaults = [
        "bucket_id",
        "name",
        "status",
        "date_init",
        "date_end",
        "description"
      ];

      if (activeBucket) {
        let searchTask = activeBucket.tasks.find(t => t.id === taskId);

        let isTaskComplete = false;
        if (!searchTask) {
          searchTask = activeBucket.taskCompletes.find(t => t.id === taskId);
          isTaskComplete = true;
        }
        if (searchTask) {
          if (defaults.includes(name)) {
            searchTask[name] = value;
            if (defaults.includes(name)) {
              const data = {
                type: name,
                value: value
              };
              this.updateDefaultValue(taskId, data);
              if (name === "bucket_id") {
                this.transferTask(bucketId, taskId, parseInt(value));
              } else {
                this.updateTaskProperty(bucketId, taskId, name, value);
              }
            }
          }
        }
      }*/
    },
    findTask(bucketId, taskId) {
      const bucket = this.buckets.find(b => b.id === bucketId);
      if (bucket) {
        let task = bucket.tasks.find(t => t.id === taskId);
        if (!task) {
          task = bucket.taskCompletes.find(t => t.id === taskId);
        }
        return (
          task ||
          console.error(`Task not found: ${taskId} in Bucket: ${bucketId}`)
        );
      }
    },
    updateTaskProperty(bucketId, taskId, propertyName, newValue) {
      const task = this.findTask(bucketId, taskId);
      if (task) {
        task[propertyName] = newValue;
        this.buckets = [...this.buckets]; // Reatribuir para garantir reatividade
      }
    },
    transferTask(bucketId, taskId, newBucketId) {
      const currentBucket = this.buckets.find(b => b.id === bucketId);
      const newBucket = this.buckets.find(b => b.id === newBucketId);
      if (currentBucket && newBucket) {
        const taskIndex = currentBucket.tasks.findIndex(t => t.id === taskId);
        if (taskIndex !== -1) {
          const [task] = currentBucket.tasks.splice(taskIndex, 1);
          task.bucket_id = newBucketId;
          newBucket.tasks.push(task);
          this.buckets = [...this.buckets]; // Garantir que Vue detecte a alteração
        }
      }
    },
    //Inativo
    updateDefaultValue(taskId, data) {
      console.log('Função inativa updateDefaultValue', taskId, data)
      /*const headers = this.$getAPIHeaders(
        "POST",
        `task-update-propertie/${taskId}`,
        data
      );
      this.axios(headers).catch(error => {
        console.error(error);
      });*/
    },
    //Usado para atualizar ordem de tasks em um bucket ou mover para outro bucket
    updateBucketData(data) {
      console.log('Função inativa updateBucketData', JSON.stringify(data))
      const headers = this.$getAPIHeaders("POST", `f-update-order-bucket`, data);
      this.axios(headers).catch(error => {
        console.error(error);
      });
    },
    displayError(error) {
      this.showMessage({
        title: error.response.data.message,
        text: this.$root.$options.filters.objectError(
          error.response.data.errors
        ),
        css: "bg-danger"
      });
    },
    //Inativo
    updateCustomPropertie(value, id) {
      console.log('Função inativa updateCustomPropertie', value, id)
      /*
      const dataID = id.split("-");
      if (dataID.length === 3) {
        const data = {
          propertie: dataID[0],
          type: dataID[1],
          task: dataID[2],
          value: value
        };
        const headers = this.$getAPIHeaders(
          "POST",
          `task-custom-propertie-value`,
          data
        );
        this.axios(headers)
          .then(response => {
            const data = response.data.data;
            this.updateOrCreateItemById(
              data.id,
              data.task_id,
              data.propertie_id,
              data.value
            );
          })
          .catch(error => {
            console.error(error);
          });
        //formModal
      }*/
    },
    updateOrCreateItemById(id, task, propertie, name) {
      if (this.formModal && this.formModal[0]) {
        const index = this.formModal[0].values.findIndex(
          item => item.id === id
        );

        if (index !== -1) {
          this.formModal[0].values[index].value = name;
        } else {
          const newItem = {
            id: id,
            task_id: task,
            propertie_id: propertie,
            value: name,
            status: true,
            created_at: new Date().toISOString(),
            updated_at: new Date().toISOString()
          };
          this.formModal[0].values.push(newItem);
        }
      }
    },
    exportBoard() {
      this.showLoader(true);
      const options = this.$getAPIHeaders(
        "POST",
        `board-export/${this.$route.params.id}`
      );
      this.axios(options)
        .then(response => {
          this.showLoader(false);
          this.showMessage({
            title: "Arquivo gerado com sucesso.",
            css: "bg-success"
          });
          const downloadUrl = response.data.data.url;
          const a = document.createElement("a");
          a.href = downloadUrl;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        })
        .catch(error => {
          console.error(error);
        });
    },
    setModalConfigShow() {
      if (this.modalShow === true) {
        this.getBucketsSilent();
        this.startUpdateInterval();
      }
      this.modalShow = !this.modalShow;
    },
    setModalExportShow() {
      this.modalExportShow = !this.modalExportShow
    },
    setModalConfigUsers(val) {
      console.log('setModalConfigUsers')
      this.modalConfigUsers = val;
    },
    openLogTask(value) {

      this.modalLogShow = true;
      this.active_id = null;
      this.log_task_id = value;
    },
    closeModalLog() {
      this.modalLogShow = false;
      this.log_task_id = null;
    }
  }
};
</script>